import { BaseModel } from "@/models/base.model"
import { type IProjectGroup } from "@/interfaces/api/project-group.interface"

export class ProjectGroup extends BaseModel implements IProjectGroup {
  public static className = "ProjectGroup"
  public static verboseName = "projectgroep"

  name: string

  constructor(projectGroup: IProjectGroup) {
    super(projectGroup)
    this.name = projectGroup.name
  }
}
